<template>
  <div style="margin-top:30px;">
    <iframe style="width:100%;height:600px" :src="url" title="W3Schools Free Online Web Tutorials"></iframe>
    <div class="row">
      <div class="col-md-10"></div>
      <div class="col-md-2">
        <el-button type="primary" v-if="reportRendered" @click="$router.push('/impressao/devedores')">Voltar</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const ls = require('local-storage')
import impressaoService from '../../services/impressaoService';
import utilitarios from '../../plugins/utilitarios';
export default {
  data: () => ({
    config: '',
    baseUrl: '',
    url: '',
    html: '',
    mesesPagos: [],
    bolseiros: ls.get('bolseiros'),
    empresa: {
      'nome_empresa': 'Colégio Bendizer',
      'localidade': 'Vila-Alice',
      'zona': 'Rangel',
      'provincia': 'Luanda',
      'telefone': '999207671',
      'email': 'ColegioBendizer@gmail.co.ao',
      'detalhes': 'Matric. Conservatória do Registo Comercial de Luanda',
      'contribuente': '5480006576',
      'NIF': '2401268340'

    },
    turma: {
      descricao:  ls.get('turma').turma,
      classe: ls.get('turma').idAno_Academico,
      curso: ls.get('turma').curso,
      anolectivo: ls.get('turma').anoLectivo,
      semestre: ls.get('turma').semestre
    },
    pagos:0,
    npagos:0,
    totalBolseiros:0,
    devedores: [], // ls.get('estudantes_'),
    // devedores: [
    //   {
    //     'nome': 'Mário Carlos',
    //     'matricula': '665557',
    //     'mes': 'Janeiro,Fevereiro,Março,Abril',
    //     'divida': '20000'
    //   }
    // ],
    formatter: 0,
    date: null,
    meses:ls.get('meses'),
    precoPropina: ls.get('precoPropina'),
    templateFull: null
  }),
  created () {
    this.config = ls.get('configuracaoinstituicao');
    this.getUrlImpressao();
    // this.getTemplateRelatorio();
   },

  methods: {
    async getUrlImpressao() {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
      } finally {
        this.html_pdf()
      }
    },

    async getTemplateRelatorio() {
      try {
          this.templateFull = await _axios.get('/obterRelatorioByDescricao/ld').then((res) => res.data[0]);
      } catch (error) {
          console.log(error);
      }
    },

    formatMoney (value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
   
    /** Compondo o cabeçario contendo os meses  */
    mesesHeader (array) {
      let arrayMesesHeadeer = `  <tr>
      <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px;">Ord.</th>
  <th bgcolor="#DCDCDC"    style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px;width:50px!important">Nome</th>
  <th bgcolor="#DCDCDC"    style="text-align:center;font-size:12px;padding-top:10px;padding-bottom:10px;">Matrícula</th>
  `
      switch (array.length) {
        case 1:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[0].descricao +`</th></tr>`
          break
        case 2:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +`</th>
        </tr>`
          break
        case 3:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px"`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        </tr>`
          break
        case 4:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +` </th>
        </tr>`
          break
        case 5:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +` </th>
        </tr>`
          break
        case 6:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[5].descricao +` </th>
        </tr>`
          break
        case 7:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[5].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[6].descricao +` </th>
        </tr>`
          break

           case 8:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[5].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[6].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[7].descricao +` </th>
        </tr>`
          break

           case 9:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[5].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[6].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[7].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[8].descricao +` </th>
        </tr>`
          break

           case 10:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[5].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[6].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[7].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[8].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[9].descricao +` </th>
        </tr>`
          break

           case 11:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[5].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[6].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[7].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[8].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[9].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[10].descricao +` </th>
        </tr>`
          break

           case 12:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px"> `+array[0].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[1].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[2].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[3].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[4].descricao +`</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[5].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[6].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[7].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[8].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[9].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[10].descricao +` </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 12px">`+array[11].descricao +` </th>
        </tr>`
          break
        default:
          arrayMesesHeadeer += `</tr>`
      }
      return arrayMesesHeadeer
    },
    /** Compondo os items dos devedores */
    rowsDivida (arrayMesesHeadeer) {
      let dados = ``
      switch (arrayMesesHeadeer.length) {
        case 1:
          this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
             
             
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
             
            

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
             
            


            mes1css = (bolseiro.length)?'bolsa':mes1css
           
            

            this.pagos += (mes1css === 'PAGO'  )?1:0
            this.npagos +=  (mes1css === 'NPAGO'   )?1:0
            this.totalBolseiros += (mes1css === 'bolsa'   )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
 
            
             </tr>`
          })

          return dados
        case 2:
          this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO')?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO')?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa')?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
             </tr>`
          })
          
          return dados
        case 3:
          this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]
            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
              
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
             

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
             


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
             

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO'  )?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO'   )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa'   )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
             
             </tr>`
          })

          return dados
        case 4:
          this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
             
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO')?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO'  )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
            
             </tr>`
          })
          return dados
        case 5:
           this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
             


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO'  )?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO'   )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa'  )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:154x;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
           <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
      
             </tr>`
          })

          return dados
        case 6:
         this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes6= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'N/PAGO'
             
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            let mes6css= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'NPAGO'
            

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
            mes6 = (bolseiro.length)?bolseiro[0].ongBolsa:mes6
       


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            mes6css = (bolseiro.length)?'bolsa':mes6css
            

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO' && mes6css === 'PAGO'  )?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO' || mes6css === 'NPAGO'  )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa' || mes6css === 'bolsa'  )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
           <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
           <td valign="top" class=`+mes6css+` style="text-align:center;font-size:14px;">`+mes6+`</td>
   
             </tr>`
          })

          return dados
         case 7:
           this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes6= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes7= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'N/PAGO'
            
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            let mes6css= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'NPAGO'
            let mes7css= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'NPAGO'
            

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
            mes6 = (bolseiro.length)?bolseiro[0].ongBolsa:mes6
            mes7 = (bolseiro.length)?bolseiro[0].ongBolsa:mes7
           


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            mes6css = (bolseiro.length)?'bolsa':mes6css
            mes7css = (bolseiro.length)?'bolsa':mes7css
       

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO' && mes6css === 'PAGO' && mes7css === 'PAGO'  )?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO' || mes6css === 'NPAGO' || mes7css === 'NPAGO'  )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa' || mes6css === 'bolsa' || mes7css === 'bolsa' )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
           <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
           <td valign="top" class=`+mes6css+` style="text-align:center;font-size:14px;">`+mes6+`</td>
           <td valign="top" class=`+mes7css+` style="text-align:center;font-size:14px;">`+mes7+`</td>
     
             </tr>`
          })

          return dados
        case 8:
           this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes6= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes7= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes8= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'N/PAGO'
            
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            let mes6css= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'NPAGO'
            let mes7css= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'NPAGO'
            let mes8css= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'NPAGO'
          

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
            mes6 = (bolseiro.length)?bolseiro[0].ongBolsa:mes6
            mes7 = (bolseiro.length)?bolseiro[0].ongBolsa:mes7
            mes8 = (bolseiro.length)?bolseiro[0].ongBolsa:mes8
  


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            mes6css = (bolseiro.length)?'bolsa':mes6css
            mes7css = (bolseiro.length)?'bolsa':mes7css
            mes8css = (bolseiro.length)?'bolsa':mes8css
 

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO' && mes6css === 'PAGO' && mes7css === 'PAGO' && mes8css === 'PAGO')?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO' || mes6css === 'NPAGO' || mes7css === 'NPAGO' || mes8css === 'NPAGO'  )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa' || mes6css === 'bolsa' || mes7css === 'bolsa' || mes8css === 'bolsa' )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
           <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
           <td valign="top" class=`+mes6css+` style="text-align:center;font-size:14px;">`+mes6+`</td>
           <td valign="top" class=`+mes7css+` style="text-align:center;font-size:14px;">`+mes7+`</td>
           <td valign="top" class=`+mes8css+` style="text-align:center;font-size:14px;">`+mes8+`</td>
  
             </tr>`
          })

          return dados
        case 9:
           this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes6= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes7= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes8= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes9= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'N/PAGO'
          
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            let mes6css= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'NPAGO'
            let mes7css= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'NPAGO'
            let mes8css= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'NPAGO'
            let mes9css= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'NPAGO'
    

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
            mes6 = (bolseiro.length)?bolseiro[0].ongBolsa:mes6
            mes7 = (bolseiro.length)?bolseiro[0].ongBolsa:mes7
            mes8 = (bolseiro.length)?bolseiro[0].ongBolsa:mes8
            mes9 = (bolseiro.length)?bolseiro[0].ongBolsa:mes9
         


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            mes6css = (bolseiro.length)?'bolsa':mes6css
            mes7css = (bolseiro.length)?'bolsa':mes7css
            mes8css = (bolseiro.length)?'bolsa':mes8css
            mes9css = (bolseiro.length)?'bolsa':mes9css
        

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO' && mes6css === 'PAGO' && mes7css === 'PAGO' && mes8css === 'PAGO' && mes9css === 'PAGO')?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO' || mes6css === 'NPAGO' || mes7css === 'NPAGO' || mes8css === 'NPAGO' || mes9css === 'NPAGO' )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa' || mes6css === 'bolsa' || mes7css === 'bolsa' || mes8css === 'bolsa' || mes9css === 'bolsa' )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
           <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
           <td valign="top" class=`+mes6css+` style="text-align:center;font-size:14px;">`+mes6+`</td>
           <td valign="top" class=`+mes7css+` style="text-align:center;font-size:14px;">`+mes7+`</td>
           <td valign="top" class=`+mes8css+` style="text-align:center;font-size:14px;">`+mes8+`</td>
           <td valign="top" class=`+mes9css+` style="text-align:center;font-size:14px;">`+mes9+`</td>
       
             </tr>`
          })

          return dados
        case 10:
           this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes6= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes7= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes8= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes9= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes10= (mesespagos.includes(this.meses[9].fkMes.toString()))?'PAGO':'N/PAGO'

   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            let mes6css= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'NPAGO'
            let mes7css= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'NPAGO'
            let mes8css= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'NPAGO'
            let mes9css= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'NPAGO'
            let mes10css= (mesespagos.includes(this.meses[9].fkMes.toString()))?'PAGO':'NPAGO'
   

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
            mes6 = (bolseiro.length)?bolseiro[0].ongBolsa:mes6
            mes7 = (bolseiro.length)?bolseiro[0].ongBolsa:mes7
            mes8 = (bolseiro.length)?bolseiro[0].ongBolsa:mes8
            mes9 = (bolseiro.length)?bolseiro[0].ongBolsa:mes9
            mes10 = (bolseiro.length)?bolseiro[0].ongBolsa:mes10
            


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            mes6css = (bolseiro.length)?'bolsa':mes6css
            mes7css = (bolseiro.length)?'bolsa':mes7css
            mes8css = (bolseiro.length)?'bolsa':mes8css
            mes9css = (bolseiro.length)?'bolsa':mes9css
            mes10css = (bolseiro.length)?'bolsa':mes10css


            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO' && mes6css === 'PAGO' && mes7css === 'PAGO' && mes8css === 'PAGO' && mes9css === 'PAGO' && mes10css === 'PAGO' )?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO' || mes6css === 'NPAGO' || mes7css === 'NPAGO' || mes8css === 'NPAGO' || mes9css === 'NPAGO' || mes10css === 'NPAGO' )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa' || mes6css === 'bolsa' || mes7css === 'bolsa' || mes8css === 'bolsa' || mes9css === 'bolsa' || mes10css === 'bolsa' )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
           <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
           <td valign="top" class=`+mes6css+` style="text-align:center;font-size:14px;">`+mes6+`</td>
           <td valign="top" class=`+mes7css+` style="text-align:center;font-size:14px;">`+mes7+`</td>
           <td valign="top" class=`+mes8css+` style="text-align:center;font-size:14px;">`+mes8+`</td>
           <td valign="top" class=`+mes9css+` style="text-align:center;font-size:14px;">`+mes9+`</td>
           <td valign="top" class=`+mes10css+` style="text-align:center;font-size:14px;">`+mes10+`</td>
             </tr>`
          })

          return dados
        case 11:
           this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes6= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes7= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes8= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes9= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes10= (mesespagos.includes(this.meses[9].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes11= (mesespagos.includes(this.meses[10].fkMes.toString()))?'PAGO':'N/PAGO'
    
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            let mes6css= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'NPAGO'
            let mes7css= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'NPAGO'
            let mes8css= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'NPAGO'
            let mes9css= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'NPAGO'
            let mes10css= (mesespagos.includes(this.meses[9].fkMes.toString()))?'PAGO':'NPAGO'
            let mes11css= (mesespagos.includes(this.meses[10].fkMes.toString()))?'PAGO':'NPAGO'
 
            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
            mes6 = (bolseiro.length)?bolseiro[0].ongBolsa:mes6
            mes7 = (bolseiro.length)?bolseiro[0].ongBolsa:mes7
            mes8 = (bolseiro.length)?bolseiro[0].ongBolsa:mes8
            mes9 = (bolseiro.length)?bolseiro[0].ongBolsa:mes9
            mes10 = (bolseiro.length)?bolseiro[0].ongBolsa:mes10
            mes11 = (bolseiro.length)?bolseiro[0].ongBolsa:mes11
 

            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            mes6css = (bolseiro.length)?'bolsa':mes6css
            mes7css = (bolseiro.length)?'bolsa':mes7css
            mes8css = (bolseiro.length)?'bolsa':mes8css
            mes9css = (bolseiro.length)?'bolsa':mes9css
            mes10css = (bolseiro.length)?'bolsa':mes10css
            mes11css = (bolseiro.length)?'bolsa':mes11css
 
            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO' && mes6css === 'PAGO' && mes7css === 'PAGO' && mes8css === 'PAGO' && mes9css === 'PAGO' && mes10css === 'PAGO' && mes11css === 'PAGO'  )?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO' || mes6css === 'NPAGO' || mes7css === 'NPAGO' || mes8css === 'NPAGO' || mes9css === 'NPAGO' || mes10css === 'NPAGO' || mes11css === 'NPAGO'  )?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa' || mes6css === 'bolsa' || mes7css === 'bolsa' || mes8css === 'bolsa' || mes9css === 'bolsa' || mes10css === 'bolsa' || mes11css === 'bolsa'  )?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
           <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
           <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
           <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
           <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
           <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
           <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
           <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
           <td valign="top" class=`+mes6css+` style="text-align:center;font-size:14px;">`+mes6+`</td>
           <td valign="top" class=`+mes7css+` style="text-align:center;font-size:14px;">`+mes7+`</td>
           <td valign="top" class=`+mes8css+` style="text-align:center;font-size:14px;">`+mes8+`</td>
           <td valign="top" class=`+mes9css+` style="text-align:center;font-size:14px;">`+mes9+`</td>
           <td valign="top" class=`+mes10css+` style="text-align:center;font-size:14px;">`+mes10+`</td>
           <td valign="top" class=`+mes11css+` style="text-align:center;font-size:14px;">`+mes11+`</td>
              </tr>`
          })

          return dados
        case 12:
        this.npagos = 0
          this.pagos=0
          this.devedores.forEach(async element => { // Lista dos estudantes  //ls.get('mesespagos') -> lista dos meses pagos
            let index = this.devedores.indexOf(element) 
            let results = ls.get('mesespagos').filter( f=>f.matricula === element.idMAtricula)
            let mesespagos = (results.length)?results[0].meses.split(','):[]

            /**
             * Verificação dos pagamentos dos meses selecionados para o estudante/matrícula filtrada
             */
            let mes1= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes2= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes3= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes4= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes5= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes6= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes7= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes8= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes9= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes10= (mesespagos.includes(this.meses[9].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes11= (mesespagos.includes(this.meses[10].fkMes.toString()))?'PAGO':'N/PAGO'
            let mes12= (mesespagos.includes(this.meses[11].fkMes.toString()))?'PAGO':'N/PAGO'
   
            //para as classes css
            let mes1css= (mesespagos.includes(this.meses[0].fkMes.toString()))?'PAGO':'NPAGO'
            let mes2css= (mesespagos.includes(this.meses[1].fkMes.toString()))?'PAGO':'NPAGO'
            let mes3css= (mesespagos.includes(this.meses[2].fkMes.toString()))?'PAGO':'NPAGO'
            let mes4css= (mesespagos.includes(this.meses[3].fkMes.toString()))?'PAGO':'NPAGO'
            let mes5css= (mesespagos.includes(this.meses[4].fkMes.toString()))?'PAGO':'NPAGO'
            let mes6css= (mesespagos.includes(this.meses[5].fkMes.toString()))?'PAGO':'NPAGO'
            let mes7css= (mesespagos.includes(this.meses[6].fkMes.toString()))?'PAGO':'NPAGO'
            let mes8css= (mesespagos.includes(this.meses[7].fkMes.toString()))?'PAGO':'NPAGO'
            let mes9css= (mesespagos.includes(this.meses[8].fkMes.toString()))?'PAGO':'NPAGO'
            let mes10css= (mesespagos.includes(this.meses[9].fkMes.toString()))?'PAGO':'NPAGO'
            let mes11css= (mesespagos.includes(this.meses[10].fkMes.toString()))?'PAGO':'NPAGO'
            let mes12css= (mesespagos.includes(this.meses[11].fkMes.toString()))?'PAGO':'NPAGO'

            let bolseiro = this.bolseiros.filter( f=>f.matricula === element.idMAtricula)
            mes1 = (bolseiro.length)?bolseiro[0].ongBolsa:mes1
            mes2 = (bolseiro.length)?bolseiro[0].ongBolsa:mes2
            mes3 = (bolseiro.length)?bolseiro[0].ongBolsa:mes3
            mes4 = (bolseiro.length)?bolseiro[0].ongBolsa:mes4
            mes5 = (bolseiro.length)?bolseiro[0].ongBolsa:mes5
            mes6 = (bolseiro.length)?bolseiro[0].ongBolsa:mes6
            mes7 = (bolseiro.length)?bolseiro[0].ongBolsa:mes7
            mes8 = (bolseiro.length)?bolseiro[0].ongBolsa:mes8
            mes9 = (bolseiro.length)?bolseiro[0].ongBolsa:mes9
            mes10 = (bolseiro.length)?bolseiro[0].ongBolsa:mes10
            mes11 = (bolseiro.length)?bolseiro[0].ongBolsa:mes11
            mes12 = (bolseiro.length)?bolseiro[0].ongBolsa:mes12


            mes1css = (bolseiro.length)?'bolsa':mes1css
            mes2css = (bolseiro.length)?'bolsa':mes2css
            mes3css = (bolseiro.length)?'bolsa':mes3css
            mes4css = (bolseiro.length)?'bolsa':mes4css
            mes5css = (bolseiro.length)?'bolsa':mes5css
            mes6css = (bolseiro.length)?'bolsa':mes6css
            mes7css = (bolseiro.length)?'bolsa':mes7css
            mes8css = (bolseiro.length)?'bolsa':mes8css
            mes9css = (bolseiro.length)?'bolsa':mes9css
            mes10css = (bolseiro.length)?'bolsa':mes10css
            mes11css = (bolseiro.length)?'bolsa':mes11css
            mes12css = (bolseiro.length)?'bolsa':mes12css

            this.pagos += (mes1css === 'PAGO' && mes2css === 'PAGO' && mes3css === 'PAGO' && mes4css === 'PAGO' && mes5css === 'PAGO' && mes6css === 'PAGO' && mes7css === 'PAGO' && mes8css === 'PAGO' && mes9css === 'PAGO' && mes10css === 'PAGO' && mes11css === 'PAGO' && mes12css === 'PAGO')?1:0
            this.npagos +=  (mes1css === 'NPAGO' || mes2css === 'NPAGO' || mes3css === 'NPAGO' || mes4css === 'NPAGO' || mes5css === 'NPAGO' || mes6css === 'NPAGO' || mes7css === 'NPAGO' || mes8css === 'NPAGO' || mes9css === 'NPAGO' || mes10css === 'NPAGO' || mes11css === 'NPAGO' || mes12css === 'NPAGO')?1:0
            this.totalBolseiros += (mes1css === 'bolsa' || mes2css === 'bolsa' || mes3css === 'bolsa' || mes4css === 'bolsa' || mes5css === 'bolsa' || mes6css === 'bolsa' || mes7css === 'bolsa' || mes8css === 'bolsa' || mes9css === 'bolsa' || mes10css === 'bolsa' || mes11css === 'bolsa' || mes12css === 'bolsa')?1:0

                dados += `<tr>
                <td valign="top" class="tptd" style="text-align:center;font-size:12px;">` + (this.devedores.indexOf(element)+1) + `</td>
                <td valign="top" class="tptd" style="text-align:justify;font-size:14px;">` + element.nome + `</td>
                <td valign="top" class="tptd" style="text-align:center;font-size:14px;" >` + element.idMAtricula + `</td>
                <td valign="top" class=`+mes1css+` style="text-align:center;font-size:14px;">`+mes1+`</td>
                <td valign="top" class=`+mes2css+` style="text-align:center;font-size:14px;">`+mes2+`</td>
                <td valign="top" class=`+mes3css+` style="text-align:center;font-size:14px;">`+mes3+`</td>
                <td valign="top" class=`+mes4css+` style="text-align:center;font-size:14px;">`+mes4+`</td>
                <td valign="top" class=`+mes5css+` style="text-align:center;font-size:14px;">`+mes5+`</td>
                <td valign="top" class=`+mes6css+` style="text-align:center;font-size:14px;">`+mes6+`</td>
                <td valign="top" class=`+mes7css+` style="text-align:center;font-size:14px;">`+mes7+`</td>
                <td valign="top" class=`+mes8css+` style="text-align:center;font-size:14px;">`+mes8+`</td>
                <td valign="top" class=`+mes9css+` style="text-align:center;font-size:14px;">`+mes9+`</td>
                <td valign="top" class=`+mes10css+` style="text-align:center;font-size:14px;">`+mes10+`</td>
                <td valign="top" class=`+mes11css+` style="text-align:center;font-size:14px;">`+mes11+`</td>
                <td valign="top" class=`+mes12css+` style="text-align:center;font-size:14px;">`+mes12+`</td>
             </tr>`
          })

          return dados
        default:
          return dados
      }
    },
    html_pdf () {
      this.devedores = ls.get('estudantes')
      this.html = `
       <html>
<head>
<style>
.tablePrincipal, .tpth, .tptd {
  border: 1px solid #ccc;
  border-collapse: collapse;
  font-size: 11px;
}
.linhas {
  border: 1px solid #808080;
}
.PAGO{
  text-align:center;
  margin-left:80px;
  font-size:5px;
  color:green;
  font-weight:bold;
  border:1px solid #ccc;
}
.bolsa{
   text-align:center;
  margin-left:80px;
  font-size:6px;
  color:blue;
  font-weight:bold;
  border:1px solid #ccc;
}
.NPAGO{
  text-align:center;
  margin-left:80px;
  font-size:5px;
  color:red;
  font-weight:bold;
  border:1px solid #ccc;
}
#rcorners2 {
   border-radius: 25px;
  border: 1px solid #000000;
  padding: 25px; 
  padding-top: 2px;
  width: 250px;
  height: 40px;
}
.column {
  float: left;
  width: 70.33%;
  padding: 5px;
}
.footer {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
}
.logo_img {
  height: 50px;
}
</style>
</head>
<body>
  
 <center style="padding-bottom:10px"> <img src="`+this.config.logo+`"  class="logo_img"/> </center>
<center class="cabecalho"> 
   REPÚBLICA DE ANGOLA <br>
   GOVERNO DA PROVÍNCIA DE LUANDA<br>
  <p style="text-transform: uppercase;">`+this.config.nome+`</p>
   </center><br><br>   
   <center> 
    Mapa de controle de Pagamentos de Propinas da turma : `+this.turma.descricao+`
   </center>     
</center>
        <table class="tablePrincipal" style="width:100%;margin-top:10px;">
        ` + this.mesesHeader(this.meses) + `
        ` + this.rowsDivida(this.meses) + `
          </table>
          <table style="border-top:1px solid #ccc;border-bottom:1px solid #ccc;border-collapse: collapse;width:100%;margin-top:40px;">
          
            <tr>
              <td style="font-size:13px;padding-top:4px;">Total de Estudantes:`+this.devedores.length+`</td>
            </tr>
            <tr>
              <td style="font-size:13px;">Total Pagos:`+this.pagos+`</td>
              <td></td>
            </tr>
            <tr>
              <td style="font-size:13px;">Total de NPagos:`+this.npagos+`</td>
              <td></td>
            </tr>
            <tr>
              <td style="font-size:13px;">Total de Bolseiros:`+this.totalBolseiros+`</td>
              <td></td>
            </tr>

            <tr>
              <td style="font-size:13px;">Preço Propina: <span style="font-weight:bold;">`+ utilitarios.IntegerToMoneyValueFatura(this.precoPropina[0].precoComIva)+`</span></td>
              <td></td>
            </tr>

              <tr>
              <td style="font-size:13px;">Total a arrecadar: <span style="font-weight:bold;">`+utilitarios.IntegerToMoneyValueFatura((this.precoPropina[0].precoComIva * this.npagos)*this.meses.length)+`</span></td>
              <td></td>
            </tr>
            
          </table>
          
</body>
</html>`
    let options = {
      'format': 'A4',
      'border': {'right': '12mm', 'left': '12mm'},
      'header': {'height': '15mm'},
      'footer': {'height': '12mm'}
    }
    impressaoService.htmlToPdf(this.html, options);
  },
    


    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
    }
  }

}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
